export function formatToBRL(value: number | string) {
  if (value == undefined) { return }
  if (typeof value === 'string') value = parseFloat(value);
  value = Math.round(value * 100) / 100
  return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}
